"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PowerTimerWeekdayEnum_1 = __importDefault(require("@signageos/lib/dist/Timer/Power/PowerTimerWeekdayEnum"));
/**
 * @deprecated use `ShortWeekEnum` from `@signageos/lib` instead
 */
const Weekday = PowerTimerWeekdayEnum_1.default;
exports.default = Weekday;
